module.exports = __webpack_public_path__ + "static/media/logo_eurofours.5c21f10a.png";